var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupTodayClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uBC18\\uBCF5_\\uADF8\\uB9AC\\uB4DC_1",
    "data-name": "\\uBC18\\uBCF5 \\uADF8\\uB9AC\\uB4DC 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8489 23102)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_22660",
    "data-name": "\\uC0AC\\uAC01\\uD615 22660",
    width: 30,
    height: 30,
    rx: 5,
    transform: "translate(-8489 -23102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_22666",
    "data-name": "\\uC0AC\\uAC01\\uD615 22666",
    width: 16,
    height: 16,
    rx: 5,
    transform: "translate(-8482 -23095)",
    fill: "#35ade3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupTodayClose);
export default __webpack_public_path__ + "static/media/popup_today_close.66ca6c0a9231d60123ad76bbbb748719.svg";
export { ForwardRef as ReactComponent };